import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
    {
        q: "Does ReachForge send emails for me?",
        a: "ReachForge sends emails from the desktop app, but it uses your own SMTP provider and sender domain. It is not a shared bulk email platform.",
    },
    {
        q: "Do I need my own SMTP provider?",
        a: "Yes. For email delivery you need SMTP details (host, port, sender email, username, password / API key). Delivery stays under your control.",
    },
    {
        q: "Does it scrape Google Maps?",
        a: "No. ReachForge uses the Google Places API when you provide your own API key. Usage is subject to Google's pricing, limits, and terms.",
    },
    {
        q: "Can I use multiple business types?",
        a: "Yes — select multiple types from suggestions in a single search, then continue saved searches with Load More Results when available.",
    },
    {
        q: "How does unsubscribe handling work?",
        a: "Outbound footers can include an unsubscribe link and reply-to-opt-out email. Suppressed addresses are stored in the suppression list and excluded from future sends.",
    },
    {
        q: "Is a licence required?",
        a: "Yes. ReachForge requires an active licence key. Plans start at £29/month or £249/year. Checkout creates and emails the key automatically.",
    },
];

export default function FAQ() {
    const [open, setOpen] = useState(0);
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="border-b border-border bg-bg"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-20 md:py-28 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-4">
                    <span className="overline">FAQ</span>
                    <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mt-4 leading-[1.05] text-ink">
                        Short answers to common setup questions.
                    </h2>
                    <p className="mt-6 text-ink-soft max-w-sm">
                        Can't find what you need? Email{" "}
                        <a
                            href="mailto:support@reachforge.io"
                            className="text-ink link-underline"
                        >
                            support@reachforge.io
                        </a>{" "}
                        — a human replies.
                    </p>
                </div>
                <div className="lg:col-span-8 border-t border-border">
                    {faqs.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={f.q}
                                className="border-b border-border"
                                data-testid={`faq-item-${i}`}
                            >
                                <button
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}
                                    data-testid={`faq-toggle-${i}`}
                                    className="w-full flex items-start justify-between gap-6 py-6 text-left"
                                >
                                    <div className="flex items-start gap-6">
                                        <span className="font-mono text-[11px] tracking-[0.2em] text-ink-mute pt-1">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <span className="font-display text-lg md:text-xl font-semibold text-ink">
                                            {f.q}
                                        </span>
                                    </div>
                                    <span className="h-7 w-7 border border-ink flex items-center justify-center shrink-0">
                                        {isOpen ? (
                                            <Minus size={14} />
                                        ) : (
                                            <Plus size={14} />
                                        )}
                                    </span>
                                </button>
                                {isOpen && (
                                    <div
                                        data-testid={`faq-answer-${i}`}
                                        className="pl-0 md:pl-[58px] pb-6 pr-12 text-ink-soft leading-relaxed fade-up"
                                    >
                                        {f.a}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
